import script from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=3a94cb37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a94cb37"]])

export default __exports__